<template>
  <div class="addRegister">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('receivablesManage.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <BasicInfo
            ref="basicInfo"
            :canEdit="canEdit"
            :receiveStatusType="'Register'"
            :departmentList="departmentList"
            :disabledBusinessType="disabledBusinessType"
            @getDepartment="getDepartment"
            @getCompanyCode="getCompanyCode"
            @getRate="getRate"
            @getPayerName="getPayerName"
            @originReceiveMoneyAmountFoo="originReceiveMoneyAmountFoo"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('receivablesManage.collapseTitle.receivablesTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <ReceivablesInfo
            ref="receivablesInfo"
            :canEdit="canEdit"
            :companyCode="companyCode"
            :departmentCode="departmentCode"
            :receiveStatus="receiveStatus"
            @resetCompany="resetCompany"
            @getRate="getRate"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        v-if="this.$route.name.indexOf('details') != -1"
        :disabled="receiveStatus && ['00', '01'].indexOf(receiveStatus) == -1"
        v-hasPermi="['2021042916124961072']"
        @click="toggleEditHandler"
        >{{ $t('functionBtn.editToggle') }}
      </el-button>
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        :disabled="!canEditBtn || (receiveStatus && ['00', '01'].indexOf(receiveStatus) == -1)"
        v-hasPermi="['2021042916115981231']"
        @click="save('00')"
        >{{ $t('functionBtn.save') }}
      </el-button>
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        :disabled="!canEditBtn || (receiveStatus && ['00', '01'].indexOf(receiveStatus) == -1)"
        v-hasPermi="['2021042916122130659']"
        @click="save('01')"
        >{{ $t('functionBtn.commit') }}
      </el-button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalCenter/receivablesManage';
  import BasicInfo from '../components/basicInfo';
  import ReceivablesInfo from '../components/receivablesInfo';
  import DataBaseAPI from '@/api/dataBase';
  export default {
    name: 'addRegister',
    components: {
      BasicInfo,
      ReceivablesInfo,
    },
    data() {
      return {
        activeNames: ['1', '2'],
        companyCode: null,
        departmentCode: null,
        departmentList: [], // 部门
        canEdit: true,
        receiveStatus: null, // 收款状态
        billIdOld: null, // 初始化票据id
        billAmountOld: null, // 初始化票据金额合计
        disabledBusinessType: true,
        allDetail: {},
        canEditBtn: true,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      if (this.$route.query.id) {
        // 修改、详情
        this.getDetail();
        // 如果是修改页面的时候
        if (this.$route.name.indexOf('editRegister') != -1) {
          this.disabledBusinessType = false;
        } else {
          this.disabledBusinessType = true;
        }
      } else {
        // 新增
        this.companyCode = this.userInfo.companyCode;
        this.departmentCode = this.userInfo.departmentCode;
        this.getDepartment(this.companyCode);
        this.disabledBusinessType = false;
      }
      if (this.$route.name.indexOf('details') != -1) {
        this.canEdit = false;
        this.canEditBtn = false;
      } // 详情
    },
    methods: {
      toggleEditHandler() {
        const { registerCreatePersonNo } = this.allDetail;
        if (registerCreatePersonNo == 'jd') {
          this.disabledBusinessType = !this.disabledBusinessType;
          this.canEditBtn = !this.canEditBtn;
          console.log(this.canEditBtn, '1111');
        } else {
          this.canEdit = !this.canEdit;
          this.canEditBtn = !this.canEditBtn;
          this.disabledBusinessType = !this.disabledBusinessType;
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
            if (this.departmentList.length == 0) {
              this.$message({ showClose: true, message: '缺少对应部门，请维护', type: 'error' });
            }
          }
        } else {
          this.departmentList = [];
        }
      },
      async getDetail() {
        // 请求详情
        this.loading.startLoading();
        let res = await this.$axios.post(API.QUERY_COLLECTIONREGISTER_BY_ID, {
          id: this.$route.query.id,
          businessGroup: this.userInfo.businessGroup,
        });
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            let allDetail = res.data.data;
            this.allDetail = res.data.data;
            this.billIdOld = allDetail.billId;
            this.billAmountOld = allDetail.originReceiveMoneyAmount;
            this.receiveStatus = allDetail.receiveStatus;
            this.companyCode = allDetail.registerCompanyCode; // 初始化公司
            this.getDepartment(this.companyCode); // 初始化部门
            const { registerCreatePersonNo } = res.data.data;
            if (registerCreatePersonNo == 'jd' && this.$route.name.indexOf('editRegister') != -1) {
              this.canEdit = false;
            }
            ['basicInfo', 'receivablesInfo'].forEach((item) => {
              let info = this.$refs[item].baseData;
              Object.keys(info).map((item) => {
                if (item.indexOf('is') == 0) {
                  return (info[item] = allDetail[item] == 'Y' ? true : false);
                } else {
                  return (info[item] = allDetail[item]);
                }
              });
            });
            // ['basicInfo', 'receivablesInfo'].map(item => {
            //   let info = this.$refs[item].baseData;
            //   Object.keys(info).map(item=>{
            //     if (item.indexOf('is') == 0) {
            //       return info[item] = allDetail[item]=='Y'?true:false;
            //     } else {
            //       return info[item] = allDetail[item];
            //     }
            //   });
            // });
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      async save(btnType, cancelValidate) {
        let basicInfo = this.$refs.basicInfo.exportChildData(btnType);
        let receivablesInfo = this.$refs.receivablesInfo.exportChildData(btnType);
        if (basicInfo && receivablesInfo) {
          if (['SK03', 'SK04'].indexOf(basicInfo.receiveMethod) != -1) {
            if (this.billIdOld == basicInfo.billId) {
              if (this.billAmountOld != receivablesInfo.originReceiveMoneyAmount) {
                return this.tips(
                  `amountValidByBill${basicInfo.receiveMethod == 'SK03' ? 'Discount' : ''}Amount`,
                  'error'
                );
              }
            } else {
              let billSelArr = this.$refs.basicInfo.billSelArr;
              let receiveMethod = basicInfo.receiveMethod;
              let statusFlag = false;
              billSelArr.map((item) => {
                if (item.billStatus != (receiveMethod == 'SK03' ? '03' : '05')) {
                  statusFlag = true;
                }
              });
              if (statusFlag) {
                return this.tips(
                  `billStatusNot${basicInfo.receiveMethod == 'SK03' ? 'Discount' : 'Collection'}`,
                  'error'
                );
              }
              let billTotalAmount = this.calcOriginReceiveMoneyAmount(billSelArr, receiveMethod);
              if (billTotalAmount == 0) {
                // 票据号-所选票据贴现所得金额总额为0
                return this.tips(
                  `bill${basicInfo.receiveMethod == 'SK03' ? 'Discount' : ''}AmountEmpty`,
                  'error'
                );
              } else if (billTotalAmount != receivablesInfo.originReceiveMoneyAmount) {
                return this.tips(
                  `amountValidByBill${basicInfo.receiveMethod == 'SK03' ? 'Discount' : ''}Amount`,
                  'error'
                );
              }
            }
          }
          this.loading.startLoading();
          let params = this.$baseRequest.assignObj({
            ...basicInfo,
            ...receivablesInfo,
            cancelValidate,
          });
          let res = await this.$axios.post(API.SAVE_COLLECTIONREGISTER, params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.returnPath();
            } else if (res.data.code === 10) {
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  this.save(btnType, true);
                },
              });
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          }
        }
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: true },
          },
          toPath: {
            path: '/capital/registerManage',
            name: 'registerManage',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      getCompanyCode(val) {
        // 获取公司代码
        this.companyCode = val;
        this.$refs.receivablesInfo.resetPayer();
        this.$refs.receivablesInfo.getLoaclCurrency(val);
      },
      resetCompany() {
        // 重置公司信息
        this.companyCode =
          this.$refs.basicInfo.baseData.registerCompanyCode =
          this.$refs.basicInfo.baseData.registerCompanyName =
            null;
        this.departmentList = [];
      },
      calcOriginReceiveMoneyAmount(val, receiveMethod) {
        let subtrahend;
        if (val && val.length > 0) {
          val.map((item) => {
            if (receiveMethod == 'SK03' && item.fundBillDiscount) {
              subtrahend = this.$cal.calCommon(
                item.fundBillDiscount.discountIncomeAmount,
                subtrahend,
                '+',
                'amount'
              );
            } else if (receiveMethod == 'SK04') {
              subtrahend = this.$cal.calCommon(item.billAmount, subtrahend, '+', 'amount');
            } else if (receiveMethod == 'SK06') {
              subtrahend = null;
            } else if (receiveMethod == 'SK07') {
              subtrahend = this.$cal.calCommon(item.acceptAmount, subtrahend, '+', 'amount');
            }
          });
        }
        return subtrahend;
      },
      originReceiveMoneyAmountFoo(val, receiveMethod) {
        this.$refs.receivablesInfo.baseData.originReceiveMoneyAmount =
          this.calcOriginReceiveMoneyAmount(val, receiveMethod);
      },
      getPayerName(val) {
        this.$refs.receivablesInfo.baseData.payerCode = val[0].customerNo;
        this.$refs.receivablesInfo.baseData.payerName = val[0].customerName;
      },
      async getRate() {
        //获取汇率
        let basicInfo = this.$refs.basicInfo.baseData;
        let receivablesInfo = this.$refs.receivablesInfo.baseData;
        if (
          basicInfo.registerDate &&
          receivablesInfo.receiveInfoCurrencyCode &&
          receivablesInfo.basicInfoCurrencyCode &&
          receivablesInfo.exchangeType
        ) {
          const params = {
            fromCurrencyCode: receivablesInfo.receiveInfoCurrencyCode,
            toCurrencyCode: receivablesInfo.basicInfoCurrencyCode,
            exchangeType: receivablesInfo.exchangeType,
            exchangeDate: basicInfo.registerDate,
          };
          if (params.fromCurrencyCode != params.toCurrencyCode) {
            let res = await this.$baseRequest.getRate(params);
            if (res) {
              receivablesInfo.exchangeRate = res.positiveRate;
            } else {
              this.$message({
                showClose: true,
                message: this.$t('receivablesManage.message.rateInfo'),
                type: 'error',
              });
              // receivablesInfo.receiveInfoCurrencyCode =
              // receivablesInfo.receiveInfoCurrencyName =
              receivablesInfo.exchangeRate = 1;
            }
          } else {
            receivablesInfo.exchangeRate = 1;
          }
        } else {
          receivablesInfo.exchangeRate = 1;
        }
        this.$refs.receivablesInfo.calcLocalAmountAll();
      },
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManage.message.${info}`),
          type: type,
        });
      },
    },
  };
</script>
